import React, { useState, useEffect } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import axios from 'axios'
import Table from '../_Components/AdminTable.js'
import { useTable } from 'react-table'
import Variables from '../../global.js'
import { call } from '../../Methods.js'
import { use } from '../../Helpers'

function _ClientRequests() {
  const pageTitle = 'Client Requests'
  const [clientRequestStats, setClientRequestStats] = useState()
  const [loading, setLoading] = useState(true)

  const defaultParameters = { statusId: '', requestType: '', pageNumber: 1, pageSize: 10, sort: 'desc' }
  const userDefinedParameters = JSON.parse(localStorage.getItem('tpp_userSettings')).searchSettings;
  let _parameters = {};
  Object.assign(_parameters, defaultParameters, userDefinedParameters.searchSettings);
  const [parameters, setParameters] = useState(_parameters)



  let tableColumns = [
    {
      title: 'Subject',
      property: ['requestType', 'requestTypeName'],
      type: 'label',
      mutate: values => {
        return (
          <span style={{ backgroundColor: use.colorsByValues([values[0]]) }}>
            {values[1]}
          </span>
        )
      }
    },
    {
      title: 'Full Name',
      property: 'fullName'
    },
    {
      title: 'E-mail',
      property: 'email'
    },
    {
      title: 'Phone',
      property: 'phone'
    },
    {
      title: 'Receive Date',
      property: 'receiveDate',
      mutate: value => {
        return use.convertUTCToLocalISOString(value);
      }
    },
    {
      title: 'Status',
      property: ['statusId', 'statusName'],
      type: 'label',
      mutate: values => {
        return (
          <span style={{ backgroundColor: use.colorsByValues(values[0]) }}>
            {values[1]}
          </span>
        )
      }
    },
    {
      title: 'Actions',
      type: 'actions-list',
      property: ['id', 'attachmentPath', 'email'],
      mutate: values => {
        return (
          <>
            <Link to={`/admin/clientrequests/${values[0]}`}>
              <img
                className='action-icon'
                title={'View'}
                src={'/Icons/view.png'}
              />
            </Link>

            {values[1] && (
              <Link
                onClick={e => {
                  e.preventDefault()
                  downloadFile(values[1], `Request #${values[0]} ${values[2]}`)
                }}
              >
                <img
                  className='action-icon'
                  title={'Download Attached File'}
                  src={'/Icons/filedownload.png'}
                />
              </Link>
            )}
          </>
        )
      }
    }
  ]

  const downloadFile = async (path, fileName) => {
    let extension = path.split('.')[1]
    await call.forLoggedUser.file.getFile(path, `${fileName}.${extension}`)
  }

  const getData = async (
    parameters
  ) => {
    const _clientRequests =
      await call.forLoggedUser.clientRequest.getClientRequests(
        parameters
      )
    if (_clientRequests.success) {
      setLoading(false)
      return _clientRequests
    }
    return false;    
  }


  const headerContent = async () => {
    const _clientRequestStats =
      await call.forLoggedUser.clientRequest.getClientRequestStats()

    if (_clientRequestStats.length) {
      setClientRequestStats(_clientRequestStats)
      return _clientRequestStats
    }

    return []
  }

  useEffect(() => {
    headerContent()
  }, []);

  return (
    <React.Fragment>
      <h3 className='page-title'>{pageTitle}</h3>
      {<Table
        columns={tableColumns}
        headerContent={
          <div className='table-header-content labels-list'>
            {clientRequestStats &&
              clientRequestStats
                .sort((a, b) => b.notSeen - a.notSeen)
                .map(row => {
                  return (
                    <Link key={row.requestType}>
                      <label
                        onClick={() => {
                          setParameters({ ...parameters, statusId: 0, requestType: row.requestType })
                        }}
                        className='table-header-label'
                        style={{
                          backgroundColor: use.colorsByValues(row.requestType)
                        }}
                      >
                        {row.requestTypeName}
                        {row.notSeen > 0 && (
                          <span
                            className='badge'
                          >
                            {row.notSeen}
                          </span>
                        )}
                      </label>
                    </Link>
                  )
                })}
          </div>
        }
        loading={loading}
        getMethod={getData}
        pagination={{
          enable: false,
          pageCount: 1,
        }}
      />}
    </React.Fragment>
  )
}

export default _ClientRequests
